const types = {
  SET_CURRENT_CLIENT: 'SET_CURRENT_CLIENT'
};
const state = {
  currentClient: null
};

const mutations = {
  [types.SET_CURRENT_CLIENT]: (state, value) => {
    state.currentClient = value;
  }
};

const actions = {};
const getters = {};

export default {
  namespaced: true,
  types,
  state,
  mutations,
  actions,
  getters
};
